import { useTranslation } from "react-i18next";
import EntityMultiSelectForm from "../../EntityMultiSelectForm";

const AssignmentStep = ({
    isPublic,
    connectors = [],
    selectedConnectorIds,
    onConnectorsChange,
    customers = [],
    customerPublicIds,
    onCustomersChange,
}) => {
    const { t } = useTranslation();

    return (
        <div className={isPublic ? "" : "grid grid-cols-1 xl:grid-cols-2 gap-8"}>
            <EntityMultiSelectForm
                title={t("entity.connectors")}
                description={
                    isPublic
                        ? t("tariff.assignmentConnectorsPublic")
                        : t("tariff.assignmentConnectorsPrivate")
                }
                fetchItems={async () => toConnectorOptions(connectors)}
                labelKey="displayName"
                valueKey="chargingConnectorPublicId"
                selectedIds={selectedConnectorIds}
                onChange={onConnectorsChange}
                reloadKey={connectors.length}
                confirmRemove={false}
            />

            {!isPublic && (
                <EntityMultiSelectForm
                    title={t("entity.customers")}
                    fetchItems={async () => customers}
                    labelKey="customerName"
                    valueKey="customerPublicId"
                    selectedIds={customerPublicIds}
                    onChange={onCustomersChange}
                    reloadKey={customers.length}
                    confirmRemove={false}
                />
            )}
        </div>
    );
};

function toConnectorOptions(connectors) {
    return (connectors || []).map((connector) => {
        const name =
            connector.chargingConnectorName || connector.chargingConnectorPublicId || "";
        const site = connector.chargingSiteName;
        return {
            ...connector,
            displayName: site ? `${site} - ${name}` : name,
        };
    });
}

export default AssignmentStep;
